import logo from "./logo.png"
import "./App.css"

const App = () => {
  const title = navigator.language === 'it_IT' ? 'Parole intrecciate multiplayer' : 'Multiplayer word search'
  const image = navigator.language === 'it_IT' ? <img alt='Disponibile su Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/it_badge_web_generic.png'/> : <img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/>
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Twisted - {title}
        </p>
        <a alt="download android" className="App-download-android" href='https://play.google.com/store/apps/details?id=com.wordsearchmobile'>
          {image}
        </a>
      </header>
    </div>
  )
}

export default App